import { useContext } from "react";
import { AlertContext } from "../app/AlertProvider";

export const useAlert = () => {
  const { showAlert } = useContext(AlertContext);
  return { showAlert };
};
